import { createSelector } from 'reselect';

import {
  // Upsell
  navigationProJobsUpsellArmstrongSelector,
  navigationPremiumUpsellArmstrongSelector,
  navigationBusinessArmstrongSelector,
  // Navigation
  navigationProJobsArmstrongSelector,
  navigationProBusinessArmstrongSelector,
  navigationEventsArmstrongSelector,
  navigationContentArmstrongSelector,
  navigationGroupsSelector,
  navigationCompaniesSelector,
  // Features
  featuresIsProJobsSelector,
  featuresIsProBusinessSelector,
  featuresShowUpsellHintSelector,
  featuresShowJobSeekerBoneyardUpsellHintSelector,
  // Feature Switches
  armstrongMarketingEntryPointMenuSelector,
  armstrongV2LogoutInSettingsSelector,
  // Extra
  navigationSettingsPersonalArmstrongSelector,
  navigationLogoutPersonalArmstrongSelector,
  hashedUserIdSelector,
} from '@xingternal/platform-layout-selectors';

const moreMenuSelector = createSelector(
  featuresIsProJobsSelector,
  navigationBusinessArmstrongSelector,
  featuresIsProBusinessSelector,
  featuresShowUpsellHintSelector,
  featuresShowJobSeekerBoneyardUpsellHintSelector,
  navigationPremiumUpsellArmstrongSelector,
  navigationProJobsArmstrongSelector,
  navigationProJobsUpsellArmstrongSelector,
  navigationProBusinessArmstrongSelector,
  navigationEventsArmstrongSelector,
  navigationContentArmstrongSelector,
  navigationGroupsSelector,
  navigationCompaniesSelector,
  navigationSettingsPersonalArmstrongSelector,
  armstrongV2LogoutInSettingsSelector,
  navigationLogoutPersonalArmstrongSelector,
  armstrongMarketingEntryPointMenuSelector,
  hashedUserIdSelector,
  (
    isProJobs,
    businessArmstrong,
    isProBusiness,
    showUpsellHint,
    showJobSeekerBoneyardUpsellHint,
    premiumUpsellArmstrong,
    proJobs,
    proJobsUpsellArmstrong,
    proBusiness,
    events,
    content,
    groups,
    companies,
    settingsPersonalArmstrong,
    isArmstrongV2LogoutInSettings,
    logoutPersonalArmstrong,
    isMarketingEntry,
    hashedUserId
  ) => {
    return {
      upsellItems: [
        showUpsellHint &&
          (showJobSeekerBoneyardUpsellHint
            ? proJobsUpsellArmstrong
            : premiumUpsellArmstrong),
        businessArmstrong,
      ].filter(Boolean),
      navigationItems: [
        isProJobs && proJobs,
        isProBusiness && proBusiness,
        events,
        content,
        groups,
        companies,
      ].filter(Boolean),
      extraItems: [
        settingsPersonalArmstrong,
        !isArmstrongV2LogoutInSettings && logoutPersonalArmstrong,
      ].filter(Boolean),
      isMarketingEntry,
      hashedUserId,
    };
  }
);

export { moreMenuSelector };
